export default class NedDocumentApi {
    getHeightContentBeforeBundles(): number {
        let result = 0;
        if (document) {
            const lPresentationBox = document.getElementsByClassName('l-presentation-box');
            if (lPresentationBox && lPresentationBox.length) {
                if (lPresentationBox[0] instanceof HTMLElement) {
                    const lPresentationBoxHeight = (lPresentationBox[0] as HTMLElement).offsetHeight;
                    result += lPresentationBoxHeight;
                    const products = document.getElementsByClassName('main-section-block products');
                    if (products && products.length) {
                        if (products[0] instanceof HTMLElement) {
                            const productsHeight = (products[0] as HTMLElement).offsetHeight;
                            result += productsHeight;
                        }
                    }
                }
            }
        }
        return result;
    }

    getScrollbarWidth(): number {
        const outer = document.createElement("div");
        outer.style.visibility = "hidden";
        outer.style.width = "100px";
    
        document.body.appendChild(outer);
    
        const widthNoScroll = outer.offsetWidth;
        // force scrollbars
        outer.style.overflow = "scroll";
    
        // add innerdiv
        const inner = document.createElement("div");
        inner.style.width = "100%";
        outer.appendChild(inner);        
    
        const widthWithScroll = inner.offsetWidth;
    
        // remove divs
        if (outer.parentNode) {
            outer.parentNode.removeChild(outer);
        }
    
        return widthNoScroll - widthWithScroll;
    }

    addPaddingForScroll() {
        const width = this.getScrollbarWidth();
        document.body.style.paddingRight = width + "px";
    }

    removePaddingForScroll() {
        document.body.style.paddingRight = "0";
    }

    showGoalWindow() {
        document.body.classList.remove("goal-window-collapsed");
        document.body.classList.remove("goal-window-collapsing");
        document.body.classList.add("goal-window-expanding");
        document.body.classList.add("goal-window-expanded");
        setTimeout(function() {
            document.body.classList.remove("goal-window-expanding");
        }, 100);
    }

    hideGoalWindow() {
        document.body.classList.remove("goal-window-expanded");
        document.body.classList.remove("goal-window-expanding");
        document.body.classList.add("goal-window-collapsing");
        document.body.classList.add("goal-window-collapsed");
        setTimeout(function() {
            document.body.classList.remove("goal-window-collapsing");
        }, 1000);
        this.setGoalWindowStateAsClosed();
    }

    setGoalWindowStateAsClosed() {
        localStorage.setItem('isGoalWindowClosed', "true");
    }

    getBodyPaddingRight(): number {
        return parseInt(window.getComputedStyle(document.body, null).getPropertyValue('padding-right'));
    }

    getBodyPaddingRightPx(): string {
        return this.getBodyPaddingRight() + "px";
    }

    calcPositionForGoalButton(): string {
        let result = 0;
        if (document) {
            const lHeader = document.getElementsByClassName('l-header');
            if (lHeader && lHeader.length) {
                if (lHeader[0] instanceof HTMLElement) {
                    const lHeaderHeight = (lHeader[0] as HTMLElement).offsetHeight;
                    const documentHeight = document.documentElement.scrollHeight;
                    const headerHeight = lHeaderHeight / documentHeight;
                    const scrollPosition = document.documentElement.scrollTop / documentHeight;
                    // Move change goal button to right.
                    if (scrollPosition <= headerHeight) {
                        result = this.getPositionRight();
                    }
                    else {
                        result = 20;
                    }
                }
            }
        }
        return (result + this.getBodyPaddingRight()) + "px";
    }

    getPositionRight(): number {
        let positionRight = 0;
        if (document) {
            const documentWidth = document.documentElement.scrollWidth;
            const userInfo = document.getElementById("user-info");
            const userInfoLeft = userInfo ? userInfo.offsetLeft : 0;
            const userInfoMarginLeft = userInfo ? parseFloat(window.getComputedStyle(userInfo).getPropertyValue("margin-left")) : 0;
            const userInfoWidth = userInfo ? userInfo.getBoundingClientRect().width : 0;
            const colSiteInfo = document.getElementById("col-site-info");
            const topSectionColPaddingLeft = colSiteInfo ? parseFloat(window.getComputedStyle(colSiteInfo, null).getPropertyValue('padding-right')) : 0;
            const bodyPaddingRight = this.getBodyPaddingRight();
            const spaceRight =  (documentWidth - (userInfoLeft - userInfoMarginLeft + userInfoWidth + 70 + topSectionColPaddingLeft) - bodyPaddingRight) / 2;
            positionRight = userInfoWidth + spaceRight + 100;
        }
        return positionRight;
    }
}